import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import { formatCurrency } from "../../../utils/formatters";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-bg-elevated border border-border rounded-xl px-4 py-3 text-xs space-y-1.5">
      <p className="font-semibold text-text-primary mb-2 truncate max-w-[160px]">
        {label}
      </p>
      {payload.map((p) => (
        <p key={p.name} style={{ color: p.color }}>
          {p.name}: {formatCurrency(p.value)}
        </p>
      ))}
    </div>
  );
};

const RevenueChart = ({ data }) => {
  if (!data?.length)
    return (
      <div className="flex items-center justify-center h-52">
        <p className="text-xs text-text-muted">No revenue data yet</p>
      </div>
    );

  return (
    <div className="h-56">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          barSize={14}
          margin={{ top: 5, right: 10, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#232E38" />
          <XAxis
            dataKey="title" // ← report uses "title" not "eventName"
            tick={{ fill: "#7B8794", fontSize: 10 }}
            tickLine={false}
            axisLine={false}
            tickFormatter={(v) => (v?.length > 20 ? v.slice(0, 20) + "…" : v)}
          />
          <YAxis
            tick={{ fill: "#7B8794", fontSize: 10 }}
            tickLine={false}
            axisLine={false}
            tickFormatter={(v) => {
              if (v >= 1000000) return `R${(v / 1000000).toFixed(1)}m`;
              if (v >= 1000) return `R${(v / 1000).toFixed(0)}k`;
              return `R${v}`;
            }}
          />
          <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: "rgba(255,255,255,0.03)" }}
          />
          <Legend wrapperStyle={{ fontSize: "11px", color: "#7B8794" }} />
          <Bar
            dataKey="ticketRevenue"
            name="Tickets"
            fill="#139679"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="extrasRevenue"
            name="Extras"
            fill="#FCA311"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueChart;
